import { api } from "../../gateways/unilabCiprianiApi";

export default {
  state: {
    profiloUtente: {},
    simboloValuta: "€"
  },
  mutations: {
    impostaProfilo(state, nuovo) {
      state.profiloUtente = nuovo;
    },
    impostaSimboloValuta(state, nuovo) {
      state.simboloValuta = nuovo;
    }
  },
  getters: {
    profiloUtente: state => state.profiloUtente,
    simboloValuta: state => state.simboloValuta
  },
  actions: {
    getUserInfoProfilo(ctx) {
      return new Promise((resolve, reject) => {
        api
          .get("general/getUserProfilo")
          .then(resp => {
            ctx.commit("impostaProfilo", resp.data);
            //alert(JSON.stringify(resp.data));
            resolve(resp);
          })
          .catch(err => {
            console.log(err);
            reject(err);
          });
      });
    },
    getSimboloValuta(ctx) {
      return new Promise((resolve, reject) => {
        api
          .get("general/simboloValuta")
          .then(resp => {
            ctx.commit("impostaSimboloValuta", resp.data);
            //alert(JSON.stringify(resp.data));
            resolve(resp);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
};

/*

{
  "idProfilo": 1,
  "descrizione": "TIE1110",
  "fluido": true,
  "vapore": true,
  "prezzi": true,
  "standarD_CALCOLO": ",C,Tech Mode,",
  "standard": ",PED,MAN,",
  "linea": ",EXP,STD,IND,ACS,DW,ANW,",
  "pressioni": ",PN06,PN10,PN16,PN25,PN31,",
  "circuitFree": true,
  "nmaX_RigheA": 6,
  "nmaX_RigheR": 3,
  "deF_PS": 90,
  "deF_PN": "PN10",
  "deF_MAT_P": "AISI316L",
  "deF_MAT_G": "NBR",
  "fluiD_GRUPPO": "ALL",
  "stampA_COMPLETA": true,
  "stampA_RIDOTTA": true,
  "stampA_PRESENTAZIONE": true,
  "grafici": false,
  "capacitY_FILTER": 0,
  "pricE_FILTER": 0,
  "pressurE_COLD": 0,
  "pressurE_HOT": 0,
  "telaiO_INOX": true,
  "simulazione": true,
  "stampA_DATI_TECNICI": false,
  "lingue": ",en,it,fr,de,es,uk,",
  "tipo": ",GPHE,BPHE,",
  "fluiD_GRUPPO_BPHE": "ALL_BPHE"
}

*/
